module.exports = __webpack_public_path__ + "static/media/TB_web_header.5ecec54d.png";